import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntRangeCalendarComponent} from "./int-range-calendar.component";
import {DateControllerModule, RangeDateControllerModule} from "../../entities";
import {IntCalendarModule} from "../int-calendar";
import {IntEmptyDividerModule} from "../../../dividers";

@NgModule({
  imports: [
    CommonModule,
    RangeDateControllerModule,
    DateControllerModule,
    IntCalendarModule,
    IntEmptyDividerModule
  ],
  declarations: [
    IntRangeCalendarComponent
  ],
  exports: [
    IntRangeCalendarComponent
  ]
})
export class IntRangeCalendarModule {}
